import React, { useEffect, useState } from 'react'
import styles from "../../../pages/DashBoard/ExternalDash/Issuer/ChangeRequest.module.css"
import API from '.././../../ApiConfig'
import { DOCUMENT_PREVIEW, REJECT_DISCREPANCY_TICKET_BY_ISSUER } from '../../../Utils/constant';
import TextBox from '../../Inputs/TextBox';
import { useNavigate } from 'react-router-dom';
import cogoToast from 'cogo-toast-react-17-fix';
import { MESSAGE } from '../../../Utils/Strings';
import Loader from '../../Loader';

export default function DenyRequest({ onClose, docID }) {

    const [Loading, setloading] = useState(false);
    const navigate = useNavigate()
    const [preview, setPreview] = useState(null)
    const [error, seterror] = useState(null)

    // useEffect(() => {
    //     API.get(DOCUMENT_PREVIEW + data.previewID, { responseType: 'blob' })
    //         .then(response => { setPreview(window.URL.createObjectURL(response.data)) })
    //         .catch(err => { setPreview(null) })
    // }, [])

    const rejectRequest = () => {
        if (message.length > 0) {
            setloading(true)
            API.post(REJECT_DISCREPANCY_TICKET_BY_ISSUER + docID, { comment: message })
                .then(res => {
                    navigate('/dashboard/credentials')
                    cogoToast.success("Ticket Resolved Successfully")
                })
                .catch(err => {
                    onClose(false)
                    if (err?.response)
                        cogoToast.error(err.response.data.message)
                    else
                        cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
                })
            .finally(() => setloading(false))
        }
        else {
            seterror("Enter Message")
        }
    }
    const [message, setmessage] = useState('')
    return (
        <div>
            <Loader isOpen={Loading} />
            <div className='topTitleBar' >
                <div>
                    <span className="topTitleBarText">Your message</span>
                    <TextBox placeholder={'Add comment'} onChange={setmessage} maxlength={255} error={error} />
                </div>
            </div>
            <hr></hr>
            <div className={styles.buttonBase + " " + styles.modalButtons}>
                <button className='btn' onClick={e => onClose()}>Cancel</button>
                <button className='btn btn-primary' onClick={e => rejectRequest()}>reject Request</button>
            </div>

        </div>

    )
}